<template>
  <div>
    <a href="#" @click.prevent="showAchievement()">
      <div class="achievements_row" v-if="achievementInfo.current">
        <div class="achievements_col">
          <img alt="" :src="getAchievementImagePath()">
        </div>
        <div class="achievements_col content">
          <h1>{{ achievementInfo.achievementLevelName }}</h1>
          <p>{{ achievementInfo.percentage }}% - {{ process() }}/{{ achievementInfo.threshold }}</p>
          <div class="progressbar">
            <div class="progressbar__bar" :data-percent="achievementInfo.percentage" ></div>
          </div>
        </div>
      </div>
      <div class="achievements_row" v-else-if="!achievementInfo.current && !achievementInfo.completed">
        <div class="achievements_col">
          <img :src="getAchievementImagePath()" alt="">
        </div>
        <div class="achievements_col content" >
          <h1>{{ achievementInfo.achievementLevelName }}</h1>
          <p>0% - 0/{{ achievementInfo.threshold }}</p>
          <div class="progressbar">
            <div class="progressbar__bar" :data-percent="0" ></div>
          </div>
        </div>
      </div>
      <div class="achievements_row" v-else-if="achievementInfo.completed && achievementInfo.prizeType == 'SPINNING_WHEEL' && !isAlreadyRedeemed()">
          <div class="achievements_col" >
            <img :src="getAchievementImagePath()" alt="">
          </div>
          <div class="achievements_col content" >
              <h1>{{ achievementInfo.achievementLevelName }}</h1>
              <p>{{ achievementInfo.percentage }}% - {{ achievementInfo.threshold }}/{{ achievementInfo.threshold }}</p>
            <button type="" class="">{{ getTranslations.home_modals_achievements_collect }}</button>
          </div>
      </div>
      <div class="achievements_row" v-else-if="(achievementInfo.completed && achievementInfo.prizeType == 'POINTS') || (achievementInfo.completed && achievementInfo.prizeType == 'SPINNING_WHEEL' && isAlreadyRedeemed())">
        <div class="achievements_col" >
          <img :src="getAchievementImagePath()" alt="">
        </div>
        <div class="achievements_col content" >
          <h1>{{ achievementInfo.achievementLevelName }}</h1>
          <p>{{ achievementInfo.percentage }}% - {{ achievementInfo.threshold }}/{{ achievementInfo.threshold }}</p>
          <div class="completed">
            <p>{{ getTranslations.home_modals_achievements_completed }}</p>
            <img src="static/images/achievements/icon-check-24px.svg">
          </div>
        </div>
      </div>
    </a>
    <component :is="currentAchievement"
               :achievement-info="buildAchievementObject()"
               @close="currentAchievement = null"/>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import AchievementInProgress from '@/components/home/modals/achievements/AchievementInProgress';
import AchievementLocked from '@/components/home/modals/achievements/AchievementLocked';
import NewAchievement from '@/components/home/modals/achievements/NewAchievement';

export default {
  name: 'achievement',
  props: {
    achievementInfo: Object,
    categoryName: String,
    achievementIndex: Number,
  },
  data() {
    return {
      currentAchievement: null,
    };
  },
  computed: {
    ...mapState('profile', [
      'achievementNotificationData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  mounted() {
    /* eslint-disable */
    $('.progressbar__bar').each(function (t, e) {
      var n = $(e).data("percent");
      $(e).width(n + "%")
    });
  },
  methods: {
    ...mapMutations('profile', [
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationId',
      'setCheckedNotificationReadStatus',
    ]),
    process() {
      const { percentage, threshold } = this.achievementInfo;
      return Math.floor(((percentage * threshold)/100))
    },
    isAlreadyRedeemed() {
      const { achievementLevelName } = this.achievementInfo;
      const matchingNotifications = (this.achievementNotificationData || []).filter(notification => notification.text === `${this.categoryName.toUpperCase()}_${achievementLevelName}`);
      if (!matchingNotifications.length) {
        return false;
      }
      const { readStatus } = matchingNotifications[0];
      return readStatus;
    },
    buildAchievementObject() {
      return { ...this.achievementInfo, image: this.getAchievementImagePath(), categoryName: this.categoryName.toUpperCase() };
    },
    getAchievementImagePath() {
      /* eslint-disable */
      //until images corrected by ui to correct the relevant paths in return statements
      let name = this.categoryName.split("_");
      if (name[2]) {
        name[0] = name[0] + '_' + name[1];
        name[1] = name[2];
      }
      if (name[1] === 'won') {
        name = name[0]+'_answers';
      } else if (name[1] === 'played') {
        name = name[0]+'_games';
      } else {
        name = this.categoryName;
      }
      if (this.achievementInfo.current) {
        return `static/images/achievements/PNGs/${name}.png`; // in progress
      } else if (!this.achievementInfo.current && this.achievementInfo.percentage === 0) {
        return `static/images/achievements/PNGs/${name}_locked.png`;//_locked -> locked
      } else if (this.achievementInfo.completed && !this.isAlreadyRedeemed() && this.achievementInfo.prizeType == 'SPINNING_WHEEL') {
        return `static/images/achievements/PNGs/${name}_new.png`;//_new -> new
      } else {
        return `static/images/achievements/PNGs/${name}.png`;// ->completed
      }
      return `static/images/achievements/PNGs/${name}.png`;
    },
    getAchievementImagePathNew() {
      return `static/images/achievements_cat/${this.categoryName}_new.png`;
    },
    getAchievementImagePathLocked() {
      return `static/images/achievements_cat/${this.categoryName}_locked.png`;
    },
    showAchievement() {
      const { current, completed } = this.achievementInfo;
      if (completed) {
        const { awardedCorrelationId, awardedPrizeDesc, achievementLevelName } = this.achievementInfo;

        this.setNotificationRewardName({ value: awardedPrizeDesc });
        this.setNotificationPrizeWon({ value: !!awardedCorrelationId });

        const categoryName = this.categoryName.toUpperCase();
        const { id, gameId, readStatus } = (this.achievementNotificationData || []).filter(notification => notification.text === `${categoryName}_${achievementLevelName}`)[0];
        this.setNotificationRewardId({ value: gameId });
        this.setCheckedNotificationId({ value: id });
        this.setCheckedNotificationReadStatus({ value: readStatus });
      }
      // eslint-disable-next-line
      this.currentAchievement = completed ? NewAchievement : current ? AchievementInProgress : AchievementLocked;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/Achievement.vue